<template>
	<div class="grid login" v-loading="loading">
		<div class="grid box info visible-xs">
			<small>L´accesso da mobile al momento é limitato.</small>
		</div>
		<div class="spacer sm"></div>
		<div class="grid box">
			<h3>Ombrelleria</h3>
			<!-- <span v-if="signupform"><small>Inserisci il tuo indirizzo email e scegli una password</small></span> -->
			<div class="spacer sm"></div>
			<el-form ref="loginform" :rules="rules" :model="login" v-if="!forgotpassword" @keyup.enter.native="signup('loginform')">
				<el-form-item label="Indirizzo email" prop="email">
					<el-input type="email" v-model="login.email"></el-input>
				</el-form-item>
				<el-form-item label="Password" prop="password">
					<el-input type="password" v-model="login.password"></el-input>
				</el-form-item>
				<el-form-item prop="agb" v-if="signupform">
					<el-checkbox v-model="login.agb"><small>accetto i <a href="https://www.iubenda.com/privacy-policy/72725701" target="new">Termini e condizioni</a></small></el-checkbox>
				</el-form-item>
				<span class="text red" style="text-align: center; width: 100%; display: block;"><small>{{errormessage}}</small></span>
				<el-form-item>
					<button type="button" class="btn dark block" :class="{'green': signupform, 'disabled': !login.agb}" @click="signupform ? signup('loginform') : loginuser('loginform')" ><span v-if="signupform">Registrati</span><span v-if="!signupform">Login</span></button>
				</el-form-item>
			</el-form>
			<el-form ref="loginform" :rules="rules" :model="login" v-if="forgotpassword" @keyup.enter.native="forgotPassword('loginform')">
				<el-form-item label="Email" prop="email">
					<el-input type="email" v-model="login.email"></el-input>
				</el-form-item>
				<span class="text red" style="text-align: center; width: 100%; display: block;"><small>{{errormessage}}</small></span>
				<el-form-item>
					<!-- <button type="button" class="btn dark block" @click="signup('loginform')" v-if="!forgotpassword">Login</button> -->
					<button type="button" class="btn dark block" @click="forgotPassword('loginform')" v-if="forgotpassword">resetta password</button>
				</el-form-item>
			</el-form>
			<div class="grid" style="text-align: center; grid-row-gap: 24px; cursor: pointer;">
				<!-- <span v-if="!signupform"><small>Ho dimenticato la password</small></span> -->
				<span @click="forgotpassword = true, errormessage = ''" v-if="!forgotpassword && !signupform"><small>Ho dimenticato la password</small></span>
				<!-- <span @click="forgotpassword = false" v-if="forgotpassword"><small>Ritorna al login</small></span> -->
				<span @click="signupform = true, errormessage = ''" v-if="!signupform && !forgotpassword"><small>Non hai un account? <span class="text green">Registrati qui</span></small></span>
				<span @click="signupform = false, forgotpassword = false, errormessage = ''" v-if="signupform || forgotpassword"><small>Ritorna al login</small></span>
			</div>
		</div>
		
		<div class="grid help">
			<transition-group name="slide-fade" mode="out-in">
				<div class="grid context" v-if="!signupform && !forgotpassword" key="help">
					<div class="grid text">
						<span>"Inserisci il tuoi dati di login per accedere alla tua spiaggia."</span>
					</div>
					<span class="author">Luca</span>
				</div>
				<div class="grid context" v-if="signupform" key="help-signup">
					<div class="grid text">
						<span>"Inserisci il tuo migliore indirizzo email e scegli una password per registrarti, subito dopo puoi creare la tua prima spiaggia."</span>
					</div>
					<span class="author">Michi</span>
				</div>
				<div class="grid context" v-if="forgotpassword" key="forgotpassword">
					<div class="grid text">
						<span>"Inserisci l´indirizzo email con il quale ti sei registrato, ti manderemo una mail per poter reimpostare la tua password."</span>
					</div>
					<span class="author">Michi</span>
				</div>
			</transition-group>
		</div>

	</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
var host = process.env.VUE_APP_API
export default {
	name: 'Home',
	data () {
		return {
			loading: false,
			signupform: false,
			forgotpassword: false,
			errormessage: '',
			login: {
				email: '',
				password: '',
				agb: ''
			},
			rules: {
				email: [
						{ required: true, type: 'email', message: 'prego controlla l´ email', trigger: 'blur' }
				],
				password: [
						{ required: true, message: 'prego inserisci una password', trigger: 'blur' },
						{ min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }
				],
				agb: [
						{ required: true, message: 'devi accettare per poterti registrare', trigger: 'change' }
				],
			}
		}
	},
	components: {
	},
	methods: {
	signup (formName) {
		console.log(this.login)
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log('login')
					this.loading = true
					this.$http
						.post(host + '/signup', {email: this.login.email.toLowerCase().trim(), password: this.login.password},
						).then((data) => {
							// this.ombrelli = data.body.ombrells
							// console.log(data.data)
							// localStorage.setItem('ombrelleria', JSON.stringify({'jwt': data.data.jwt, 'user': data.data.user}))
							this.$store.commit('LOAD_JWT', data.data)
							// localStorage.setItem('profile', data.body.profile)
							this.$store.dispatch('hotels/getHotels').then(success => {
								this.$store.dispatch('ombrelloni/getOmbrelloni').then(success => {
									this.$router.replace('/')
									this.loading = false
								}, error => {
									this.loading = false
									this.errormessage = 'Si é verificato un errore, prego riprovare'
								})
							}, error => {
								this.loading = false
								this.errormessage = 'Si é verificato un errore, prego riprovare'
							})
							// this.getHotel()
						}, (error) => {
							console.log(error)
							this.loading = false
							// this.error.state = true
							this.errormessage = error.body.error
						})
				} else {
					console.log('error submit!!')
					// return false
				}
			})
		},
		loginuser (formName) {
		console.log(this.login)
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log('login')
					this.loading = true
					this.$http
						.post(host + '/login', {email: this.login.email.toLowerCase().trim(), password: this.login.password},
						).then((data) => {
							// this.ombrelli = data.body.ombrells
							// console.log(data.data)
							// localStorage.setItem('ombrelleria', JSON.stringify({'jwt': data.data.jwt, 'user': data.data.user}))
							this.$store.commit('LOAD_JWT', data.data)
							// localStorage.setItem('profile', data.body.profile)
							this.$store.dispatch('hotels/getHotels').then(success => {
								this.$store.dispatch('ombrelloni/getOmbrelloni').then(success => {
									this.$router.replace('/')
									this.loading = false
								}, error => {
									this.loading = false
									this.errormessage = 'Si é verificato un errore, prego riprovare'
								})
							}, error => {
								this.loading = false
								this.errormessage = 'Si é verificato un errore, prego riprovare'
							})
							// this.getHotel()
						}, (error) => {
							console.log(error)
							this.loading = false
							// this.error.state = true
							this.errormessage = error
						})
				} else {
					console.log('error submit!!')
					// return false
				}
			})
		},
		forgotPassword (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log('forgotPassword')
					this.loading = true
					this.$http
						.post(host + '/forgot', {email: this.login.email.toLowerCase().trim()},
						).then((data) => {
							// this.ombrelli = data.body.ombrells
							console.log(data)
							this.errormessage = 'link mandato, controlla le tue mail'
							// localStorage.setItem('profile', data.body.profile)
							this.loading = false
							// this.getHotel()
						}, (error) => {
							console.log(error)
							this.errormessage = error.data.error
							this.loading = false
							// this.error.state = true
							// this.error.message = error.body.error
						})
				} else {
					console.log('error submit!!')
					// return false
				}
			})
		}
	},
	created () {
		console.log(process.env.NODE_ENV)
		if (localStorage.getItem('ombrelleria')) {
			console.log('redirect')
			this.$router.replace('/')
		}
		console.log(this.$route.query.signup ? 'yes' : 'nope')
		this.$route.query.signup ? this.signupform = true : ''
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
	transition: opacity .5s;
}
.fade-leave-active {
	transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(10px);
	opacity: 0;
}
</style>
